export const selectDashboardData = (state) => state.dashboard.data;
export const selectLegacyDashboardData = (state) => state.legacyDashboard.data;
export const selectSystemTotals = (state) => state.legacyDashboard.systemTotals;
export const selectSystemTotalsLoading = (state) => state.legacyDashboard.systemTotalsLoading;
